//const apiUrl = 'http://3.7.17.152:5000/';
//const apiUrl = 'http://localhost:5000/';
//http://localhost:5000/'
const apiUrl = 'https://web.mybiocalculus.com:3002/';

export default apiUrl;